import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system';
import { useWatch } from 'react-hook-form';

import { useBookingConfig } from 'reservations/account/providers/ConfigProvider';
import getTimeSlotSpan from 'reservations/availabilities/helpers/getTimeSlotSpan';
import type { Slot } from 'reservations/availabilities/types';

const TimeSlot = styled(Button)({
  borderRadius: '0',
  fontSize: '16px',
  height: '56px'
}) as typeof Button;

type BaseTimeSlotsProps = {
  handleSlotClick: (_timeSlot: string) => void;
  name: string;
  slots: (Slot | null)[];
};

const BaseTimeSlots = ({
  slots,
  handleSlotClick,
  name
}: BaseTimeSlotsProps) => {
  const { slotSize } = useBookingConfig();
  const date = useWatch({
    name: 'date'
  });
  const timeSlotSpan = getTimeSlotSpan(slotSize);

  return (
    <>
      {slots.map((slot, index) => {
        const key = `${date}-${slot?.time12 ?? null}-${slotSize}-${index}`;

        if (!slot) {
          return (
            <Grid item key={key} xs={timeSlotSpan}>
              <TimeSlot
                aria-label="unavailable"
                disabled
                fullWidth
                variant="contained"
              />
            </Grid>
          );
        }

        const { time12, status } = slot;
        const formattedTime = time12.replace(' ', '');
        const isDisabled = status === 0;

        return (
          <Grid item key={key} xs={timeSlotSpan}>
            <TimeSlot
              disabled={isDisabled}
              fullWidth
              name={name}
              onClick={() => handleSlotClick(time12)}
              variant="contained"
            >
              {formattedTime}
            </TimeSlot>
          </Grid>
        );
      })}
    </>
  );
};

export default BaseTimeSlots;
